import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AddInitialCashModule } from '../core/components/add-initial-cash/add-initial-cash.module';
import { ManageAliasModule } from '../core/components/manage-alias/manage-alias.module';
import { PricingPlansModule } from '../core/components/pricing-plans/pricing-plans.module';
import { SetLoyaltyPointsModule } from '../core/components/set-loyalty-points/set-loyalty-points.module';
import { CardPaymentModule } from '../includes/payments/card-payment/card-payment.module';
import { CardReaderPaymentModule } from '../includes/payments/card-reader-payment/card-reader-payment.module';
import { CashPaymentModule } from '../includes/payments/cash-payment/cash-payment.module';
import { ChargeActionSheetPageModule } from '../includes/payments/charge-action-sheet/charge-action-sheet.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CashPaymentModule,
    CardPaymentModule,
    CardReaderPaymentModule,
    FormsModule,
    ReactiveFormsModule,
    ChargeActionSheetPageModule,
    AddInitialCashModule,
    SetLoyaltyPointsModule,
    ManageAliasModule,
    TranslateModule,
    PricingPlansModule,
  ],

  exports: [TranslateModule],
})
export class CoreModule {}
